var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 33.425L5.225 36.75C5.625 37.45 6.2 38 6.87499 38.4L13.75 26.5H0C0 27.275 0.2 28.05 0.6 28.75L3.3 33.425Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.825 12.5L14.95 0.600037C14.275 1.00004 13.7 1.55004 13.3 2.25004L0.6 24.25C0.207356 24.9349 0.000522781 25.7105 0 26.5H13.75L21.825 12.5Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7749 38.4C37.4499 38 38.0249 37.45 38.4249 36.75L39.2249 35.375L43.0499 28.75C43.4499 28.05 43.6499 27.275 43.6499 26.5H29.8989L32.8249 32.25L36.7749 38.4Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8247 12.5L28.6997 0.6C28.0247 0.2 27.2497 0 26.4497 0H17.1997C16.3997 0 15.6247 0.225 14.9497 0.6L21.8247 12.5Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 26.5H13.75L6.875 38.4C7.55 38.8 8.325 39 9.125 39H34.525C35.325 39 36.1 38.775 36.775 38.4L29.9 26.5Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7002 13.25L30.3502 2.25004C29.9502 1.55004 29.3752 1.00004 28.7002 0.600037L21.8252 12.5L29.9002 26.5H43.6252C43.6252 25.725 43.4252 24.95 43.0252 24.25L36.7002 13.25Z",
    fill: "#FFBA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.51c8f65695353bbcdc9febd9f8dde4fe.svg";
export { ForwardRef as ReactComponent };